<div class="modal-body">
  <div class="quotation-modal__content w-100">
    <h1 class="quotation-modal__header">
      <div i18n="@@branch.have_branch" class="text-center">Do you have more than one branch</div>
      <div i18n="@@branch.multiple_store" class="text-center">(multiple stores)?</div>
    </h1>
    <div class="d-flex align-items-center gap-2 w-100 mt-auto pt-5">
        <button class="secondary_btn w-100" data-dismiss="modal" i18n="@@branch.no" (click)="setBranches(0)">NO</button>
        <button class="primary_btn w-100 text-white" data-dismiss="modal"  i18n="@@branch.yes" (click)="setBranches()">Yes</button>
    </div>
  </div>
</div>